import * as Yup from 'yup';

export const crisisPlanSchema = Yup.object().shape({
  id: Yup.number().optional(),
  is_needed: Yup.bool().default(false),
  crisis_description: Yup.string().trim().required().min(10),
  antecedent_intervention: Yup.string().trim().required(),
  precursor: Yup.string().trim().required(),
  behavior_intervention_plan: Yup.string().trim().required(),
  consequence_strategy: Yup.string().trim().required(),
  follow_up_step: Yup.string().trim().required(),
});

export const crisisPlanInitialState = {
  crisis_description: '',
  antecedent_intervention: '',
  precursor: '',
  behavior_intervention_plan: '',
  consequence_strategy: '',
  follow_up_step: '',
};
